module.exports = __webpack_public_path__ + "img/law1.95add082.jpg";